import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import PropTypes from 'prop-types';
import settings from '../../devices/all/settings';
import Utils from '../../utils/Utils';
import { COLORFILTERBUTTON } from '../../AAFPlayer/constants';

import {
  Column,
  Row,
  Button,
  cls
} from '../../packages/components';

import './styles/AAFModalDocumentType.scss';
import {CLASS_NAME_DEFAULT_FOCUSABLE_LIST_INFINITE} from "../Focus/constants";



const ModalFilter = (props = {}) => {

    const {
      handleClose,
      orderItems,
      setChargeList,
    } = props;
    const customizedClassName =`modal-button-return`;

    const p = {
      alwaysEnabled: true,
      buttonsAlign: 'vertical',
      aafNewStyle: true,
      className: 'aaf-modal',
      showLogo: false,
      yellowAction: () => {
        setChargeList(false);
        Utils.setInitialFocusChangeTime(`.${CLASS_NAME_DEFAULT_FOCUSABLE_LIST_INFINITE}`, 0)
        handleClose()
      },
      colorButtons: [
        {
          content: Translator.get('top_head_option_button_back', 'REGRESAR'),
          props: {
            color: 'yellow',
            className: customizedClassName,
            imgSrc: Assets.get('top_head_option_back', ''),
            onClick: () => {
              setChargeList(false);
              Utils.setInitialFocusChangeTime(`.${CLASS_NAME_DEFAULT_FOCUSABLE_LIST_INFINITE}`, 0)
              handleClose()
            },
            id: 'id_yellow_button'
          }
        }
      ]
    };

    const manejarBlur = (event) => {
      event.target.style.backgroundColor = COLORFILTERBUTTON;
    };


    const elementsOrder = orderItems !== undefined ? orderItems : [];
    return (
      <ModalWrapper {...p}>
        <Row>
          {
            elementsOrder.map((items, key) => {
            return (
              <Row className='modal-row-button-documents'>
                <Column lg={12} key={items}>
                  <Button
                    id={`modal-filter-button-${key}`}
                    onBlur={manejarBlur}
                    activate
                    type="button"
                    className={cls('focusable', 'modal-button-documents-filter')}
                    onClick= {(e) => {
                      setChargeList(false);
                      const detail = items.order;
                      document.dispatchEvent(
                        new CustomEvent(settings.button_filter, { detail })
                      );
                      Utils.setInitialFocusChangeTime(`.${CLASS_NAME_DEFAULT_FOCUSABLE_LIST_INFINITE}`, 0)
                      props.handleClose();
                    }}>
                    {Utils.htmlDecode(items.label)}
                  </Button>
                </Column>
              </Row>
            )})
          }
        </Row>
      </ModalWrapper>
    );

};

ModalFilter.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

export default withOnClose(ModalFilter);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalFilter.jsx